export enum FitType {
  WIDTH = 'WIDTH',
  HEIGHT = 'HEIGHT',
}
